import log from "loglevel"

// 设置默认日志级别
log.setDefaultLevel("debug");

// 定义日志接口
interface Logger {
    trace: (...args: any[]) => void;
    debug: (...args: any[]) => void;
    info: (...args: any[]) => void;
    warn: (...args: any[]) => void;
    error: (...args: any[]) => void;
}

// 扩展 log 方法，为每一级日志添加时间戳
const originalMethods = ["trace", "debug", "info", "warn", "error"];
const loggerbase : Logger = {
    trace: function (...args: any[]): void {
        throw new Error("Function not implemented.");
    },
    debug: function (...args: any[]): void {
        throw new Error("Function not implemented.");
    },
    info: function (...args: any[]): void {
        throw new Error("Function not implemented.");
    },
    warn: function (...args: any[]): void {
        throw new Error("Function not implemented.");
    },
    error: function (...args: any[]): void {
        throw new Error("Function not implemented.");
    }
};

originalMethods.forEach((method) => {
    loggerbase[method] = (...args) => {
        const timestamp = new Date().toLocaleString(); // 获取当前时间的 ISO 格式
        log[method](`[${timestamp}]`, ...args); // 打印时间戳和日志内容
    };
});

export const logger = loggerbase;